export default __webpack_public_path__ + "static/media/weight.f23ab18b.svg";